export default __webpack_public_path__ + "static/media/Ballroll_00280.e03ef331.png";